























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { TypeformAPI } from '@/api/client/typeform'
import { TypeformTheme } from '@/api/model/typeform/typeform-theme'
import { TypeformImage } from '@/api/model/typeform/typeform-image'

@Component
export default class EditTypeformThemeForm extends Vue {
    @Prop({ required: true }) readonly value!: TypeformTheme
    backgroundUploading: boolean = false
    backgroundError: boolean = false
    logoUploading: boolean = false
    logoError: boolean = false

    async uploadBackground(file: File): Promise<void> {
        if (!this.isAcceptedImage(file)) {
            this.backgroundError = true
            return
        } else {
            this.backgroundError = false
        }

        this.backgroundUploading = true

        try {
            const image = await this.uploadImage(file)

            this.value.background = {
                href: image.src,
                layout: 'fullscreen',
                brightness: 0,
            }
        } catch {
            this.value.background = null
        } finally {
            this.backgroundUploading = false
        }
    }

    async uploadLogo(file: File): Promise<void> {
        if (!this.isAcceptedImage(file)) {
            this.logoError = true
            return
        } else {
            this.logoError = false
        }

        this.logoUploading = true

        try {
            const image = await this.uploadImage(file)

            this.value.logo = {
                href: image.src,
            }
        } catch {
            this.value.logo = null
        } finally {
            this.logoUploading = false
        }
    }

    async uploadImage(file: File): Promise<TypeformImage> {
        return await TypeformAPI.createImage(file)
    }

    get acceptedImageTypes(): string[] {
        return ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml']
    }

    isAcceptedImage(file: File): boolean {
        return this.acceptedImageTypes.includes(file.type)
    }

    get layoutOptions() {
        const layouts = [
            'fullscreen',
            'repeat',
            'no-repeat',
        ]

        return layouts.map(layout => ({
            label: this.$t(`forms.edit_typeform_theme_form.background.layout_options.${layout}`).toString(),
            value: layout,
        }))
    }

    get fontOptions() {
        const fonts = [
            'Acme',
            'Arial',
            'Arvo',
            'Avenir Next',
            'Bangers',
            'Cabin',
            'Cabin Condensed',
            'Courier',
            'Crete Round',
            'Dancing Script',
            'Exo',
            'Georgia',
            'Handlee',
            'Helvetica Neue',
            'Karla',
            'Lato',
            'Lekton',
            'Lobster',
            'Lora',
            'McLaren',
            'Montserrat',
            'Nixie One',
            'Old Standard TT',
            'Open Sans',
            'Oswald',
            'Playfair Display',
            'Quicksand',
            'Raleway',
            'Signika',
            'Sniglet',
            'Source Sans Pro',
            'Vollkorn',
        ]

        return fonts.map(font => ({
            label: font,
            value: font,
        }))
    }

    get fontSizeOptions() {
        const fontSizes = [
            'small',
            'medium',
            'large',
        ]

        return fontSizes.map(fontSize => ({
            label: this.$t(`forms.edit_typeform_theme_form.font_size_options.${fontSize}`).toString(),
            value: fontSize,
        }))
    }

    get alignmentOptions() {
        const alignments = [
            'left',
            'center',
        ]

        return alignments.map(alignment => ({
            label: this.$t(`forms.edit_typeform_theme_form.alignment_options.${alignment}`).toString(),
            value: alignment,
        }))
    }
}
